// extracted by mini-css-extract-plugin
module.exports = {"flowColumn":"appLayout_flowColumn__9qF4X"};